// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TaskCatalogTableMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TaskCatalogTableMetadataQuery = { __typename?: 'Query', globalPlanTags: Array<{ __typename?: 'GlobalPlanTag', id: string, name: string }> };

export type TaskCatalogTableQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.GlobalPlanTaskFilter>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type TaskCatalogTableQuery = { __typename?: 'Query', globalPlanTasks: { __typename?: 'GlobalPlanTasksPageResult', entities: Array<{ __typename?: 'GlobalPlanTask', id: string, name: string, description: string, numberOfTimesUsed: number, optimisticDurationInDays: number, pessimisticDurationInDays: number, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }, constraints: Array<{ __typename?: 'GlobalPlanConstraint', id: string }>, allowances: Array<{ __typename?: 'GlobalPlanAllowance', id: string }>, tags: Array<{ __typename?: 'GlobalPlanTag', id: string, name: string }>, variants: Array<{ __typename?: 'GlobalPlanTaskVariant', id: string }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type TaskCatalogTable_GlobalPlanTaskFragment = { __typename?: 'GlobalPlanTask', id: string, name: string, description: string, numberOfTimesUsed: number, optimisticDurationInDays: number, pessimisticDurationInDays: number, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }, constraints: Array<{ __typename?: 'GlobalPlanConstraint', id: string }>, allowances: Array<{ __typename?: 'GlobalPlanAllowance', id: string }>, tags: Array<{ __typename?: 'GlobalPlanTag', id: string, name: string }>, variants: Array<{ __typename?: 'GlobalPlanTaskVariant', id: string }> };

export type TaskCatalogTable_GlobalPlanTagFragment = { __typename?: 'GlobalPlanTag', id: string, name: string };

export const TaskCatalogTable_GlobalPlanTagFragmentDoc = gql`
    fragment TaskCatalogTable_GlobalPlanTag on GlobalPlanTag {
  id
  name
}
    `;
export const TaskCatalogTable_GlobalPlanTaskFragmentDoc = gql`
    fragment TaskCatalogTable_GlobalPlanTask on GlobalPlanTask {
  id
  name
  description
  businessFunctionType {
    code
    name
  }
  constraints {
    id
  }
  allowances {
    id
  }
  tags {
    ...TaskCatalogTable_GlobalPlanTag
  }
  numberOfTimesUsed
  variants {
    id
  }
  optimisticDurationInDays
  pessimisticDurationInDays
}
    ${TaskCatalogTable_GlobalPlanTagFragmentDoc}`;
export const TaskCatalogTableMetadataDocument = gql`
    query TaskCatalogTableMetadata {
  globalPlanTags {
    ...TaskCatalogTable_GlobalPlanTag
  }
}
    ${TaskCatalogTable_GlobalPlanTagFragmentDoc}`;

/**
 * __useTaskCatalogTableMetadataQuery__
 *
 * To run a query within a React component, call `useTaskCatalogTableMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCatalogTableMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCatalogTableMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskCatalogTableMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskCatalogTableMetadataQuery, TaskCatalogTableMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCatalogTableMetadataQuery, TaskCatalogTableMetadataQueryVariables>(TaskCatalogTableMetadataDocument, options);
      }
export function useTaskCatalogTableMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCatalogTableMetadataQuery, TaskCatalogTableMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCatalogTableMetadataQuery, TaskCatalogTableMetadataQueryVariables>(TaskCatalogTableMetadataDocument, options);
        }
// @ts-ignore
export function useTaskCatalogTableMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogTableMetadataQuery, TaskCatalogTableMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogTableMetadataQuery, TaskCatalogTableMetadataQueryVariables>;
export function useTaskCatalogTableMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogTableMetadataQuery, TaskCatalogTableMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogTableMetadataQuery | undefined, TaskCatalogTableMetadataQueryVariables>;
export function useTaskCatalogTableMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogTableMetadataQuery, TaskCatalogTableMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskCatalogTableMetadataQuery, TaskCatalogTableMetadataQueryVariables>(TaskCatalogTableMetadataDocument, options);
        }
export type TaskCatalogTableMetadataQueryHookResult = ReturnType<typeof useTaskCatalogTableMetadataQuery>;
export type TaskCatalogTableMetadataLazyQueryHookResult = ReturnType<typeof useTaskCatalogTableMetadataLazyQuery>;
export type TaskCatalogTableMetadataSuspenseQueryHookResult = ReturnType<typeof useTaskCatalogTableMetadataSuspenseQuery>;
export type TaskCatalogTableMetadataQueryResult = Apollo.QueryResult<TaskCatalogTableMetadataQuery, TaskCatalogTableMetadataQueryVariables>;
export const TaskCatalogTableDocument = gql`
    query TaskCatalogTable($filter: GlobalPlanTaskFilter, $page: PageFilter) {
  globalPlanTasks(filter: $filter, page: $page) {
    entities {
      ...TaskCatalogTable_GlobalPlanTask
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    ${TaskCatalogTable_GlobalPlanTaskFragmentDoc}`;

/**
 * __useTaskCatalogTableQuery__
 *
 * To run a query within a React component, call `useTaskCatalogTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCatalogTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCatalogTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTaskCatalogTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskCatalogTableQuery, TaskCatalogTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskCatalogTableQuery, TaskCatalogTableQueryVariables>(TaskCatalogTableDocument, options);
      }
export function useTaskCatalogTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskCatalogTableQuery, TaskCatalogTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskCatalogTableQuery, TaskCatalogTableQueryVariables>(TaskCatalogTableDocument, options);
        }
// @ts-ignore
export function useTaskCatalogTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogTableQuery, TaskCatalogTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogTableQuery, TaskCatalogTableQueryVariables>;
export function useTaskCatalogTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogTableQuery, TaskCatalogTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskCatalogTableQuery | undefined, TaskCatalogTableQueryVariables>;
export function useTaskCatalogTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskCatalogTableQuery, TaskCatalogTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskCatalogTableQuery, TaskCatalogTableQueryVariables>(TaskCatalogTableDocument, options);
        }
export type TaskCatalogTableQueryHookResult = ReturnType<typeof useTaskCatalogTableQuery>;
export type TaskCatalogTableLazyQueryHookResult = ReturnType<typeof useTaskCatalogTableLazyQuery>;
export type TaskCatalogTableSuspenseQueryHookResult = ReturnType<typeof useTaskCatalogTableSuspenseQuery>;
export type TaskCatalogTableQueryResult = Apollo.QueryResult<TaskCatalogTableQuery, TaskCatalogTableQueryVariables>;